import { render, staticRenderFns } from "./AddNewSundryCostPopUp.vue?vue&type=template&id=753c970b&scoped=true&"
import script from "./AddNewSundryCostPopUp.vue?vue&type=script&lang=js&"
export * from "./AddNewSundryCostPopUp.vue?vue&type=script&lang=js&"
import style0 from "./AddNewSundryCostPopUp.vue?vue&type=style&index=0&id=753c970b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753c970b",
  null
  
)

export default component.exports